import React from "react";

export default function Track() {
  return (
    <div
      style={{
        padding: "40px",
        textAlign: "center",
        fontFamily: "Arial, sans-serif",
        color: "#2d3e50",
      }}
    >
      <h1 style={{ fontSize: "28px", marginBottom: "12px" }}>
        Track Orders
      </h1>

      <p style={{ fontSize: "16px", opacity: 0.75, maxWidth: "500px", margin: "0 auto" }}>
        This page will allow clinics to search orders by clinic name and patient name.
        (UI coming soon.)
      </p>
    </div>
  );
}
